module.exports = __webpack_public_path__ + "img/uploadIcon.png";